import { Components, LinkProps, Theme } from "@mui/material";
import { LinkBehavior } from "../../components/LinkBehavior";
export const MuiLink: Components<Omit<Theme, "components">>["MuiLink"] = {
  defaultProps: {
    component: LinkBehavior,
  } as LinkProps,
};
